<!-- Notificación de Preferencias -->
@if (showThemeNotification()) {
<div
  class="fixed bottom-6 right-6 z-[60] min-w-[340px] max-w-sm bg-white dark:bg-slate-800 rounded-2xl shadow-[0_15px_50px_-12px_rgba(0,0,0,0.25)] dark:shadow-[0_15px_50px_-12px_rgba(0,0,0,0.6)] flex items-center p-4 border-b-4 border-emerald-500 dark:border-emerald-400 animate-slide-in-left-bounce">
  <!-- Icon -->
  <div
    class="flex-shrink-0 w-12 h-12 bg-emerald-50 dark:bg-emerald-900/40 rounded-2xl flex items-center justify-center text-emerald-500 dark:text-emerald-400 mr-4 shadow-sm border border-emerald-100 dark:border-emerald-800/50">
    <mat-icon class="!w-7 !h-7 text-[28px] leading-none flex items-center justify-center">check_circle</mat-icon>
  </div>
  <!-- Content -->
  <div class="flex-1">
    <h4 class="text-slate-800 dark:text-white font-semibold text-[17px] m-0 mb-0.5 leading-tight tracking-tight">
      {{ 'header.preferences.updatedTitle' | translate }}</h4>
    <p class="text-slate-500 dark:text-slate-400 text-[14px] m-0 leading-snug">{{ 'header.preferences.updatedSubtitle' | translate }}</p>
  </div>
  <!-- Close Button -->
  <button (click)="showThemeNotification.set(false)"
    class="text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 ml-4 transition-colors flex items-center justify-center !w-8 !h-8 bg-transparent hover:bg-slate-100 dark:hover:bg-slate-700 rounded-full">
    <mat-icon class="text-xl !w-5 !h-5 leading-none flex items-center justify-center">close</mat-icon>
  </button>
</div>
}

<mat-toolbar class="topbar gap-2 shadow-sm transition-all duration-300 px-6 min-h-[76px]">
  <!-- Sidebar Toggle Button (Mobile y Desktop) -->
  <button mat-icon-button (click)="showToggle ? toggleCollapsed.emit() : toggleMobileNav.emit()"
    class="flex justify-center items-center hover:bg-gray-100 dark:hover:bg-gray-800 transition-all duration-300 rounded-lg group relative">
    <svg
      class="w-6 h-6 text-gray-500 dark:text-gray-400 group-hover:text-gray-700 dark:group-hover:text-gray-300 transition-all duration-200"
      fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
    </svg>
  </button>

  <div *hasRole="['ADMIN']" class="text-sm text-gray-800 dark:text-gray-200">
    <p>{{currentUserSignal()?.empresaNombre}}</p>
    <p>{{currentUserSignal()?.empresaRuc}}</p>
  </div>

  <!-- Selector global de empresa (persistente) -->
  @if (empresaContext.empresas().length > 0) {
  <app-empresa-selector-global></app-empresa-selector-global>
  }

  <span class="flex-auto"></span>

  <!-- Theme Toggle with smooth animation -->
  <div class="relative group mx-1">
    @if (options.theme == 'light') {
    <button mat-icon-button aria-label="Switch to dark mode"
      class="flex items-center justify-center hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-all duration-300 rounded-full relative overflow-hidden"
      (click)="setlightDark('dark')">
      <i class="iconify text-2xl transition-all duration-500 hover:rotate-180 hover:text-blue-600"
        data-icon="solar:moon-line-duotone"></i>
      <span
        class="absolute inset-0 rounded-full bg-blue-500/10 scale-0 group-hover:scale-100 transition-transform duration-300"></span>
    </button>
    <span
      class="absolute -bottom-8 left-1/2 -translate-x-1/2 px-2 py-1 bg-gray-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
      {{ 'header.theme.darkMode' | translate }}
    </span>
    } @else {
    <button mat-icon-button aria-label="Switch to light mode"
      class="flex items-center justify-center hover:bg-yellow-50 dark:hover:bg-yellow-900/20 transition-all duration-300 rounded-full relative overflow-hidden"
      (click)="setlightDark('light')">
      <i class="iconify text-2xl transition-all duration-500 hover:rotate-180 hover:text-yellow-500"
        data-icon="solar:sun-2-line-duotone"></i>
      <span
        class="absolute inset-0 rounded-full bg-yellow-500/10 scale-0 group-hover:scale-100 transition-transform duration-300"></span>
    </button>
    <span
      class="absolute -bottom-8 left-1/2 -translate-x-1/2 px-2 py-1 bg-gray-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
      {{ 'header.theme.lightMode' | translate }}
    </span>
    }
  </div>

  <!-- --------------------------------------------------------------- -->
  <!-- Selector de Idiomas -->
  <!-- --------------------------------------------------------------- -->
  <button mat-icon-button [matMenuTriggerFor]="flags"
    class="flex justify-center items-center hover:bg-gray-100 dark:hover:bg-gray-800 transition-all duration-300 rounded-full w-10 h-10 mx-1">
    <img [src]="selectedLanguage.icon" alt="language"
      class="w-6 h-6 rounded-full object-cover shadow-[0_2px_4px_rgba(0,0,0,0.1)]">
  </button>
  <mat-menu #flags="matMenu" xPosition="before" yPosition="below" class="cardWithShadow language-menu min-w-[180px]">
    @for (lang of languages; track lang.code) {
    <button mat-menu-item (click)="changeLanguage(lang)" class="language-menu__item"
      [class.language-menu__item--active]="selectedLanguage.code === lang.code">
      <div class="flex w-full items-center gap-3">
        <img [src]="lang.icon" alt="flag" class="w-5 h-5 rounded-full object-cover shadow-sm">
        <span class="flex-1 text-sm font-medium text-gray-700 dark:text-gray-200">{{ lang.language }}</span>
        <span class="language-menu__status" [class.language-menu__status--active]="selectedLanguage.code === lang.code">
          <mat-icon class="language-menu__check">check</mat-icon>
        </span>
      </div>
    </button>
    }
  </mat-menu>

  <!-- --------------------------------------------------------------- -->
  <!-- Notification Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <button mat-icon-button matBadge="5" matBadgeColor="warn" [matMenuTriggerFor]="notificationmenu"
    aria-label="{{ 'header.notifications.title' | translate }}" class="notification-badge relative mx-1">
    <i class="iconify text-2xl" data-icon="solar:bell-line-duotone"></i>
    <span class="absolute top-2 right-2 w-2 h-2 bg-error rounded-full animate-pulse"></span>
  </button>
  <mat-menu #notificationmenu="matMenu" class="topbar-dd cardWithShadow notification-menu">
    <div class="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <div>
        <h6 class="text-lg font-semibold mb-0">{{ 'header.notifications.title' | translate }}</h6>
        <p class="text-xs text-muted mb-0">{{ 'header.notifications.subtitle' | translate }}</p>
      </div>
      <button mat-icon-button class="text-emerald-600 dark:text-emerald-400">
        <i class="iconify" data-icon="solar:settings-line-duotone"></i>
      </button>
    </div>

    <div class="notification-menu__body max-h-80 overflow-y-auto">
      @for (notification of notifications; track notification.id) {
      <button mat-menu-item class="px-6 py-3 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors">
        <div class="flex gap-3 items-start">
          <img [src]="notification.img" class="rounded-full w-10 h-10 ring-2 ring-white dark:ring-gray-800"
            [alt]="notification.title" />
          <div class="flex-1">
            <h5 class="text-sm font-semibold mb-1">
              {{ notification.title | translate }}
            </h5>
            <span class="text-xs text-muted">{{ notification.subtitle | translate }}</span>
            <p class="text-xs text-emerald-600 dark:text-emerald-400 mt-1">{{ 'header.notifications.justNow' | translate }}</p>
          </div>
        </div>
      </button>
      }
    </div>

    <div class="px-6 py-3 border-t border-gray-200 dark:border-gray-700 text-center">
      <button mat-button color="primary" class="w-full">{{ 'header.notifications.viewAll' | translate }}</button>
    </div>
  </mat-menu>

  <!-- --------------------------------------------------------------- -->
  <!-- profile Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <button mat-icon-button extended [matMenuTriggerFor]="profilemenu" aria-label="Mi cuenta"
    class="flex! items-center justify-center profile-btn-dd gap-2 mx-1">
    <img [src]="avatarUrl()" class="rounded-full object-cover icon-35 profile-dd" width="35"
      alt="Avatar" />
  </button>
  <mat-menu #profilemenu="matMenu" class="cardWithShadow profile-menu" yPosition="below" [overlapTrigger]="false" xPosition="after">
    <!-- Datos del usuario autenticado (currentUserSignal() para reactividad) -->
    @if (currentUserSignal(); as user) {
    <div class="px-4 py-3 border-b border-gray-200 dark:border-gray-700 min-w-[220px]">
      <p class="text-sm font-semibold text-gray-900 dark:text-gray-100 m-0">
        {{ displayName || user.username }}
      </p>
      @if (displayEmail) {
      <p class="text-xs text-gray-500 dark:text-gray-400 m-0 mt-1 truncate">
        {{ displayEmail }}
      </p>
      }
    </div>
    }

    <div class="px-1 py-1">
      @if (showMiPerfil()) {
      <button mat-menu-item (click)="openMiPerfil()" class="w-full px-4 py-2.5">
        <mat-icon class="!w-5 !h-5 flex items-center justify-center">
          <i data-icon="solar:shield-user-line-duotone" class="iconify icon-22"></i>
        </mat-icon>
        <span class="ml-2 text-sm">{{ 'header.profile.myProfile' | translate }}</span>
      </button>
      }

      <button mat-menu-item (click)="openConfiguracion()" class="w-full px-4 py-2.5">
        <mat-icon class="!w-5 !h-5 flex items-center justify-center">
          <i data-icon="solar:settings-line-duotone" class="iconify icon-22"></i>
        </mat-icon>
        <span class="ml-2 text-sm">{{ 'header.profile.configuration' | translate }}</span>
      </button>

      <button mat-menu-item (click)="openSoporte()" class="w-full px-4 py-2.5">
        <mat-icon class="!w-5 !h-5 flex items-center justify-center">
          <i data-icon="solar:info-circle-line-duotone" class="iconify icon-22"></i>
        </mat-icon>
        <span class="ml-2 text-sm">{{ 'header.profile.support' | translate }}</span>
      </button>
    </div>

    <div class="mx-4 my-1 border-t border-gray-200 dark:border-gray-700"></div>

    <button mat-menu-item (click)="logout()" class="w-full px-4 py-2.5">
      <mat-icon class="!w-5 !h-5 flex items-center justify-center">
        <i data-icon="solar:logout-2-line-duotone" class="iconify icon-22"></i>
      </mat-icon>
      <span class="ml-2 text-sm">{{ 'header.profile.logout' | translate }}</span>
    </button>
  </mat-menu>
</mat-toolbar>
